(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAnnouncementBar(sectionId) {
    var carouselId = 'ab-carousel-' + sectionId;
    var wrapper = document.getElementById(carouselId);
    if (!wrapper) return;

    var section = wrapper.closest('.announcement-bar-section');
    if (!section) return;

    var track = wrapper.querySelector('.ab-carousel-track');
    var slides = wrapper.querySelectorAll('.ab-slide');
    var prevBtn = section.querySelector('.ab-prev');
    var nextBtn = section.querySelector('.ab-next');

    if (!track || slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var autoplaySpeed = parseFloat(getComputedStyle(section).getPropertyValue('--ab-autoplay-speed')) || 3;
    var timer = null;
    var isHovered = false;

    function goTo(index) {
      if (index >= total) index = 0;
      if (index < 0) index = total - 1;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (total <= 1) return;
      timer = setInterval(function() {
        if (!isHovered) next();
      }, autoplaySpeed * 1000);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        next(); stopAutoplay(); startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prev(); stopAutoplay(); startAutoplay();
      });
    }

    section.addEventListener('mouseenter', function() { isHovered = true; });
    section.addEventListener('mouseleave', function() { isHovered = false; });

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[id^="ab-carousel-"]').forEach(function(el) {
      var sectionId = el.id.replace('ab-carousel-', '');
      initAnnouncementBar(sectionId);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function(event) {
    var el = event.target.querySelector('[id^="ab-carousel-"]');
    if (el) initAnnouncementBar(el.id.replace('ab-carousel-', ''));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-selling"] && !Shopify.designMode) return;
  try {
    
(function() {
  var swiperInstances = {};

  function initSwiper(sectionId) {
    var el = document.getElementById('cl-swiper-' + sectionId);
    if (!el) return;

    var section = el.closest('.collection-list-section');
    var autoplay = section.dataset.autoplay === 'true';
    var speed = parseInt(section.dataset.speed) || 3000;
    var transitionSpeed = parseInt(section.dataset.transitionSpeed) || 600;
    var desktopCols = parseInt(section.dataset.desktopColumns) || 3;
    var mobileCols = parseInt(section.dataset.mobileColumns) || 1;
    var gap = parseInt(section.dataset.gap) || 16;

    if (swiperInstances[sectionId]) {
      swiperInstances[sectionId].destroy(true, true);
    }

    swiperInstances[sectionId] = new Swiper('#cl-swiper-' + sectionId, {
      loop: true,
      speed: transitionSpeed,
      spaceBetween: gap,
      slidesPerView: mobileCols,
      autoplay: autoplay ? {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      navigation: {
        prevEl: '#cl-prev-' + sectionId,
        nextEl: '#cl-next-' + sectionId
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: gap },
        1017: { slidesPerView: desktopCols, spaceBetween: gap }
      }
    });
  }

  function loadSwiperAndInit(sectionId) {
    if (window.Swiper) {
      initSwiper(sectionId);
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = function() { initSwiper(sectionId); };
    document.head.appendChild(script);
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.collection-list-section').forEach(function(section) {
      var id = section.id.replace('shopify-section-', '');
      loadSwiperAndInit(id);
    });
  });

  document.addEventListener('shopify:section:load', function(e) {
    loadSwiperAndInit(e.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
